import Icon from 'veui/components/Icon'
import { IconAbstract } from 'dls-icons-vue'

Icon.register('abstract', IconAbstract)
